/*@ngInject*/
const MultiStepSelectorWidgetController = function ($rootScope, $scope, configurationConstant, configurationMediator, localization, coreConstant) {

    localization.getTranslationByKey('multiStepSelectorWidget').then(function (translations) {

        this.init = function () {
            this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
            this.searchForStep1 = this.mode === 'forms' ? translations.searchForAForm : translations.searchForAObject;
            this.searchForStep2 = this.mode === 'forms' ? translations.searchForAField : translations.searchForAProperty;
            this.selectedStep1Label = this.mode === 'forms' ? translations.selectedForm : translations.selectedObject;
            this.isWidgetOpen = false;
            this.step1Items = [];
            this.step1ItemsFilter = [];
            this.step2Items = [];
            this.step2ItemsFilter = [];
            this.displayStep1Section = false;
            this.displayStep1Items = false;
            this.displayStep2Section = false;
            this.searchDelayInMilliSeconds = 750;
            this.step1SearchValue = _.isNil(this.step1ItemName) ? '' : this.step1ItemName;
            this.step2SearchValue = '';
            this.widgetOpened = false;
            this.selectedStep2ItemName = '';
            this.itemName = 'multiStepSelector';
            this.displayStep2MultiSelect = this.step2MultiSelect;
            this.tooltip = '';
            this.showClearIcon = false;

            if (!_.isEmpty(this.step1ItemName)) {
                if (!_.isEmpty(this.step2ItemName)) {
                    this.dropDownPrompt = this.getDropDownPrompt(this.step1ItemName, this.step2ItemName);
                    this.showClearIcon = true;
                } else {
                    this.selectStep1Item(this.step1ItemName);
                }
            }

        };

        this.$onChanges = function (changes) {
            if (changes.mode) {
                if (!_.isUndefined(changes.mode.currentValue) && !_.isUndefined(changes.mode.previousValue)) {
                    this.step1ItemName = null;
                    this.step2ItemName = null;
                    this.showClearIcon = false;
                    $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {});
                }
                this.reset();
                this.init();
            }

            if (!_.isNil(changes.step2MultiSelect) && changes.step2MultiSelect.previousValue !== changes.step2MultiSelect.currentValue) {

                var step2MultiList = _.filter(this.step2MultiItemsFilter, function (item) {
                        return item.selected;
                    }),
                    _step2MultiItemsFilter;

                this.displayStep2MultiSelect = changes.step2MultiSelect.currentValue;

                if (changes.step2MultiSelect.previousValue === true && step2MultiList.length !== 0) {
                    if (step2MultiList.length > 1) {
                        this.step1ItemName = null;
                        this.step2ItemName = null;
                        this.showClearIcon = false;
                        this.init();
                        this.reset();
                        $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, null, []);
                    } else {
                        this.selectStep1Item(this.step1ItemName);
                        this.selectedStep2ItemName = step2MultiList[0].name;
                        this.dropDownPrompt = this.getDropDownPrompt(this.step1ItemName, step2MultiList[0].name);
                        this.showClearIcon = true;
                    }
                }

                if (changes.step2MultiSelect.previousValue === false) {
                    _step2MultiItemsFilter = this.step2MultiItemsFilter;
                    this.step2MultiItemsFilter = [];
                    _.each(_step2MultiItemsFilter, function (item) {
                        if (item.name === this.selectedStep2ItemName) {
                            item.selected = true;
                        }
                        this.step2MultiItemsFilter.push(item);
                    }.bind(this));
                    this.selectedStep2ItemName = this.step2ItemName;
                }
            }
        };

        this.openForm = function (event) {
            event.stopPropagation();
            if (this.step1SearchValue !== '' && _.isNil(this.selectedStep1ItemName)) {
                this.step1SearchValue = '';
                this.step1SearchChange();
            }

            if (this.step2SearchValue !== '') {
                this.step2SearchValue = '';
                this.step2SearchChange();
            }

            if (!this.widgetOpened) {
                if (!_.isNil(this.step1ItemName) && !_.isNil(this.step2ItemName) && this.step1ItemName !== '' && this.step2ItemName !== '') {
                    this.selectedStep2ItemName = this.step2ItemName;
                    this.selectStep1Item(this.step1ItemName, event);
                } else {
                    if (_.isNil(this.step1ItemName) || _.isEmpty(this.step1ItemName)) {
                        this.loadStep1Data();
                    }
                }
                this.widgetOpened = true;
            }

            if (!_.isNil(this.step1ItemName) && !_.isNil(this.selectedStep1ItemName)) {
                $scope.$broadcast('step2SearchFocus');
            } else {
                $scope.$broadcast('step1SearchFocus');
            }
        };

        this.removeSelection = function (event) {
            event.stopPropagation();
            this.change(event);
            this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
            $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {}, false, this.name);
            this.showClearIcon = false;
        };


        this.selectorMenuClick = function (event) {
            if (event.target.getAttribute('class').match('multiSelectButton')) {
                event.stopPropagation();
            }
        };

        this.multiSelectStep2Click = function (event) {
            if (event.target.getAttribute('class').match('multiSelectStep2')) {
                event.stopPropagation();
            }
        };

        this.step1SearchChange = function () {
            if (this.mode === 'objects') {
                this.step1ItemsFilter = _.filter(this.step1Items, function (item) {
                    return _.lowerCase(item).indexOf(_.lowerCase(this.step1SearchValue)) !== -1;
                }.bind(this));
            } else {
                this.loadStep1Data();
            }
        };

        this.step2SearchChange = function () {
            var itemName;
            this.step2ItemsFilter = _.filter(this.step2Items, function (item) {
                itemName = item.fieldName ? item.fieldName : item.propertyName;
                return _.toUpper(itemName).indexOf(_.toUpper(this.step2SearchValue)) !== -1;
            }.bind(this));
        };

        this.change = function (event) {
            event.stopPropagation();
            this.tooltip = '';
            this.reset();
        };

        this.reset = function () {
            this.step1Items = [];
            this.step2Items = [];
            this.displayStep1Section = false;
            this.displayStep2Section = false;
            this.step1SearchValue = '';
            this.step2SearchValue = '';
            this.loadStep1Data();
            this.selectedStep1ItemName = null;
            this.selectedStep2ItemName = null;
            this.searchForStep1 = this.mode === 'forms' ? translations.searchForAForm : translations.searchForAObject;
            this.searchForStep2 = this.mode === 'forms' ? translations.searchForAField : translations.searchForAProperty;
            this.selectedStep1Label = this.mode === 'forms' ? translations.selectedForm : translations.selectedObject;
        };

        this.getItemName = function (item) {
            if (this.mode === 'forms') {
                return item.fieldName;
            } else if (this.mode === 'objects') {
                return item.propertyName;
            }
        };

        this.loadStep1Data = function () {
            if (this.mode === 'forms') {
                this.displayStep1Section = true;
                if (this.step1SearchValue !== '') {
                    this.displayStep1Items = true;
                    configurationMediator.getUIFormTemplatesByMatchingName(this.step1SearchValue).then(function (result) {
                        this.step1ItemsFilter = result;
                    }.bind(this));
                } else {
                    this.displayStep1Items = false;
                    this.step1ItemsFilter = [];
                }
            } else if (this.mode === 'objects') {
                this.displayStep1Section = true;
                this.displayStep1Items = true;
                configurationMediator.getObjectNames(this.step1SearchValue).then(function (result) {
                    this.step1ItemsFilter = result;
                    this.step1Items = result;
                }.bind(this));
            }
        };

        this.selectStep1Item = function (itemName, event) {
            if (event) {
                event.stopPropagation();
            }
            this.displayStep1Section = false;
            this.displayStep2Section = true;
            this.selectedStep1ItemName = itemName;
            this.dropDownPrompt = this.getDropDownPrompt(itemName, this.selectedStep2ItemName);
            this.showClearIcon = true;

            if (this.mode === 'forms') {
                configurationMediator.getFieldOptions(itemName).then(function (result) {
                    this.step2Items = result;
                    this.step2ItemsFilter = result;
                    this.step2MultiItemsFilter = [];
                    _.each(result, function (item) {
                        var obj = {};
                        obj.name = item.fieldName;
                        obj.value = item.fieldName;
                        this.step2MultiItemsFilter.push(obj);
                    }.bind(this));
                    $scope.$emit(configurationConstant.event.FORM_COMPONENT_SELECTED, this.selectedStep1ItemName, null);
                }.bind(this));
            } else if (this.mode === 'objects') {
                configurationMediator.getObjectPropertyValues(itemName).then(function (result) {
                    this.step2Items = result;
                    this.step2ItemsFilter = result;
                }.bind(this));
            }
        };

        this.checkStep1AndStep2Selected = function () {
            return ((this.dropDownPrompt === translations.selectAFormField ||
                this.dropDownPrompt === translations.selectAFormField) ||
                this.step1AndStep2Selected);
        };

        this.selectStep2Item = function (item, event) {
            this.dropDownPrompt = this.getDropDownPrompt(this.selectedStep1ItemName, (this.mode === 'forms' ? item.fieldName : item.propertyName));
            this.selectedStep2ItemName = this.getItemName(item);
            $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, this.selectedStep1ItemName, item, false, this.name);
        };

        this.step2BoxClick = function (event) {
            if (_.isNil(event.target.getAttribute('class'))) {
                event.stopPropagation();
            }
        };

        this.getDropDownPrompt = function (item1, item2) {
            var dropDownPrompt;
            if( _.isEmpty(item2)) {
                dropDownPrompt = '(' + item1 + ')';

            } else {
                dropDownPrompt = (!_.isEmpty(item2) ? item2 + ' ' : '') + '(' + item1 + ')';
            }
            // Recalculate the tooltip here as well
            if (dropDownPrompt.length > 40) {
                this.tooltip = dropDownPrompt;
            } else {
                this.tooltip = '';
            }
            return dropDownPrompt;
        };

        this.isDropup = function () {
            var dropmenu = $('.uib-dropdown');
            if (dropmenu.offset().top + dropmenu.outerHeight() + 300 /*height of the selectorMenu*/ > $(window).innerHeight() + $(window).scrollTop()) {
                return true;
            }
            return false;
        };

        $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
            if (this.itemName === itemName) {
                this.refreshDropDownPrompt(itemName);
            }
        }.bind(this));

        $scope.$on(coreConstant.event.REFRESH_MULTI_SELECT, function(event, step1Name,step2Name, name){
            if(name === this.name){
                this.step1ItemName = step1Name;
                this.step2ItemName = step2Name;
                this.init();
                if (_.isEmpty(this.step1ItemName)) {
                    this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
                    $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {}, false, this.name);
                    this.showClearIcon = false;
                }
            }
        }.bind(this))

        this.refreshDropDownPrompt = function (itemName) {
            var step2MultiList = _.filter(this.step2MultiItemsFilter, function (item) {
                    return item.selected;
                }),
                truncatedNames = '',
                names = _.map(step2MultiList, 'name');
            names = _.join(names, ', ');
            truncatedNames = _.truncate(names, {length: 75, seperator: /,? +/});
            if (!_.isUndefined(this.selectedStep1ItemName)) {
                this.dropDownPrompt = this.getDropDownPrompt(this.selectedStep1ItemName, truncatedNames);
            }
            $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, this.selectedStep1ItemName, names, true);
        };

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('multiStepSelectorWidgetController', MultiStepSelectorWidgetController);
